import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const ConsumableDetailsPage = () => {
  const history = useHistory();
  const match = useRouteMatch<{ consumableId: string }>();

  useEffect(() => {
    if (match.isExact) {
      const { consumableId } = match.params;

      history.push(
        `/app/operational/inventory/consumables/${consumableId}/general`,
      );
    }
  }, [match]);

  return null;
};

export default ConsumableDetailsPage;
